export default {
  title: '传播效果分析',
  icon: 'line-chart',
  path: '/spread',
  hideSub: true,
  children: ((pre) => [
    {
      title: '矩阵榜单',
      icon: 'dot-circle-o',
      children: [
        {
          title: '微信榜单',
          icon: 'dot-circle-o',
          path: `${pre}analysis_wechat`
        },
        {
          title: '微博榜单',
          icon: 'dot-circle-o',
          path: `${pre}analysis_weibo`
        },
        {
          title: '头条榜单',
          icon: 'dot-circle-o',
          path: `${pre}analysis_toutiao`
        }
      ]
    },
    {
      title: '热文排名',
      icon: 'dot-circle-o',
      path: '/spread/hot',
      children: [
        {
          title: '微信热文',
          icon: 'dot-circle-o',
          path: `${pre}hot_wechat`
        },
        {
          title: '微博热文',
          icon: 'dot-circle-o',
          path: `${pre}hot_weibo`
        },
        {
          title: '头条热文',
          icon: 'dot-circle-o',
          path: `${pre}hot_toutiao`
        }
      ]
    },
    {
      title: '绩效管理',
      icon: 'dot-circle-o',
      path: `${pre}kpi`
    },
    // {
    //   title: '分析汇总',
    //   icon: 'dot-circle-o',
    //   path: `${pre}overview`
    // },
    // {
    //   title: '选题分析',
    //   icon: 'dot-circle-o',
    //   path: `${pre}topic`
    // },
    // {
    //   title: '矩阵榜单',
    //   icon: 'dot-circle-o',
    //   path: `${pre}rank`
    // },
    // {
    //   title: '热文排名',
    //   icon: 'dot-circle-o',
    //   path: `${pre}hot`
    // },
    // {
    //   title: '绩效统计',
    //   icon: 'dot-circle-o',
    //   path: `${pre}kpi`
    // },
    {
      title: '传播效果统计分析',
      icon: 'dot-circle-o',
      path: `${pre}effect`
    },
    {
      title: '热文分析',
      icon: 'dot-circle-o',
      path: `${pre}hotAnalysis`
    },
    {
      title: '热文单篇分析',
      icon: 'dot-circle-o',
      path: `${pre}aloneAnalysis`
    },
    {
      title: '发布概况',
      icon: 'dot-circle-o',
      path: `${pre}preState`
    },
    {
      title: '分析汇总',
      icon: 'dot-circle-o',
      path: `${pre}totalAnalysis`
    },
    {
      title: '选题分析',
      icon: 'dot-circle-o',
      path: `${pre}topicAnalysis`
    },
    {
      title: '绩效评分设置',
      icon: 'dot-circle-o',
      path: `${pre}scoreSetting`
    },
    {
      title: '账号画像',
      icon: 'dot-circle-o',
      path: `${pre}accountPicture`
    },

    {
      title: '账号分析',
      icon: 'dot-circle-o',
      path: '/accountAnalysis',
      children: [
        {
          title: '微信',
          icon: 'dot-circle-o',
          path: `${pre}accountAnalysis_wx`
        }
      ]
    }

  ])('/spread/')
}
